import { Manage_admin_service } from "../services/Manage_admin_service";
import router from "../router/router"
import { MessageBox } from 'element-ui';
import Cookie from "cookies-js";
import { Loading } from 'element-ui';
import moment from "moment";

const state = {
    data_table: [],
    total : 0,
    edit_id: null,
    ad_group: [],
    user_table: [],
    edit_data : {},
    label_position: "top",
    permissions : {
        Manage_user: ["Manage_user"],
        Manage_admin: ["Manage_admin"],
        Manage_operator: ["Manage_operator"],
        Typegroup: ["Typegroup"],
        ListOperator: ["ListOperator"],
        Manage_averagetosave: ["Manage_averagetosave"],
        Promotion_table_avg: ["Promotion_table_avg"],
        Manage_service: ["Manage_service"],
        Manage_question: ["Manage_question"],
        Manage_article: ["Manage_article"],
        Manage_news: ["Manage_news"],
        Manage_mobile: ["Manage_mobile"],
        Manage_internet: ["Manage_internet"],
        Manage_request_mobile: ["Manage_request_mobile"],
        Manage_request_internet: ["Manage_request_internet"],
        Manage_data: ["Manage_data"],
        Upload_save: ["Upload_save"],
        Report_promotion_mobile_type: ["Report_promotion_mobile_type"],
        Services_rate: ["Services_rate"],
        Program_technologies: ["Program_technologies"],
        Services_change: ["Services_change"],
        Pro_seconds_G5: ["Pro_seconds_G5"],
        Promotion_percent: ["Promotion_percent"],
        Services_trends: ["Services_trends"],
        Fast_internet_home_G9: ["Fast_internet_home_G9"],
        Services_internet: ["Services_internet"],
        Report_blockchain: ["Report_blockchain"],
        Fast_internet_home_G11: ["Fast_internet_home_G11"],
        Fast_internet_home_G12: ["Fast_internet_home_G12"],
        Reportview_promotion: ["Reportview_promotion"],
        Manage_mobile_service : ['Manage_mobile_service'],
        Popular_proMobile:['Popular_proMobile'],
        Popular_proInternet:['Popular_proInternet'],
        Access_log: ['Access_log'],
        Report_promotion_ranking : ['Report_promotion_ranking'],
        User_behavior: ['User_behavior'],
        Manage_terms_and_condition: ['Manage_terms_and_condition'],
        Manage_privacy_data_policy: ['Manage_privacy_data_policy'],
        Manage_security_policy: ['Manage_security_policy'],
        Manage_cookie_privacy: ['Manage_cookie_privacy'],
        Uteleme: ['Uteleme'],
        Manage_banner: ['Manage_banner']
    },
    permission_add : ['Manage_admin','Manage_operator','Typegroup','ListOperator','Manage_averagetosave','Manage_service','Manage_question','Manage_article','Manage_news'],
    permission_edit: ['Manage_user','Manage_admin','Manage_operator','Typegroup','ListOperator','Manage_averagetosave','Manage_service','Manage_question','Manage_article','Manage_news','Manage_mobile_service','Manage_banner'],
    permission_delete: ['Manage_user','Manage_admin','Manage_operator','Typegroup','ListOperator','Manage_averagetosave','Manage_service','Manage_question','Manage_article','Manage_news','Upload_save'],
    loading: false
};
const actions = {
    add_admin({ commit }, data) {
        data.registered_by = $cookies.get('user_nbtc').admin_id;
        data.company_provider_id = data.company_provider_id ? data.company_provider_id : null
        let go_save = Manage_admin_service.add_admin_service(data);
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        go_save.subscribe({
            error: function(err) {
                if (err.status === 230 || err.status === 225) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                    setTimeout(function(){ loadingInstance.close() }, 250);
                }
            },
            next: function(resource) {
                setTimeout(function(){ loadingInstance.close() }, 250);
                MessageBox.confirm('เพิ่มข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'success'
                }).then((response) => {
                    if(data.company_provider_id == null){
                        router.push({ name: 'Manage_admin' })
                    } else {
                        router.push({ name: 'Manage_operator' })
                    }
                }).catch(() => {
                    router.push({ name: 'Manage_admin' })
                });
            }
        });
    },
    async search_admin({ commit }, formdata) {
        commit('LOADING', true)
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_admin_service.search_admin(formdata)
        if(result.status == 200){
            commit('SET_DATA_TABLE',result.data)
            setTimeout(()=>{
                commit('LOADING', false)
                loadingInstance.close()
            }, 250)
        }else{
            setTimeout(()=>{
                commit('LOADING', false)
                loadingInstance.close()
            }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },
    async update_admin({ commit,state }, forminfo) {
            forminfo.append("admin_id", state.edit_data.admin_id)
            forminfo.append("first_name", state.edit_data.first_name)
            forminfo.append("last_name", state.edit_data.last_name)
            forminfo.append("username", state.edit_data.username)
            forminfo.append("phone_number", state.edit_data.phone_number)
            forminfo.append("email", state.edit_data.email)
            forminfo.append("departments", state.edit_data.departments)
            forminfo.append("profile_img", state.edit_data.profile_img)
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Manage_admin_service.updateAdmin(forminfo)
        let userinfo = JSON.parse(Cookie.get('user_nbtc'));
        if(result.status === 200){
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                if(userinfo.admin_id == state.edit_data.admin_id){
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                }else{
                    router.push({name : 'Manage_admin'})
                }
            }).catch(() => {
                router.push({ name: 'Login' })
            });
        }else{
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },
    deleteAdmin({ commit }, data) {
        let go_delete = Manage_admin_service.deleteAdmin(data);
        go_delete.subscribe({
            error: function(err) {
                if (err.status === 230 || err.status === 225) {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    }).catch(() => {
                        $cookies.remove('user_nbtc')
                        router.push({ name: 'Login' })
                    });
                } else {
                    MessageBox.confirm(err.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {}).catch(() => {});
                }
            },
            next: function(resource) {
                MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'success'
                }).then(() => {
                    commit('CUT_TABLE', data)
                }).catch(() => {
                    commit('CUT_TABLE', data)
                });
            }
        });
    },
    async getAdGroup({commit,dispatch}, formdata){
        let result = await Manage_admin_service.getAdGroup(formdata)
        if(result.status === 200){
            commit('SET_AD_GROUP', result.data)
            dispatch('getAdUsers', {
                email : '',
                firstName : '',
                groupDN : result.data[0].dn,
                lang : 'th',
                lastName : '',
                username : ''
            })
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    },

    async getAdUsers({commit}, formdata){
        let result = await Manage_admin_service.getAdUsers(formdata)
        if(result.status == 200){
            commit('SET_USER_TABLE', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {}).catch(() => {});
        }
    }
};

const mutations = {
    SET_DATA_TABLE(state, data) {
        state.total = data[0] ? data[0].total : 0
        for(let i in data){
            data[i].username = data[i].username.replace('@nbtc.domain', '')
            data[i].created_at = data[i].created_at ? moment(data[i].created_at).add(543,'Y').format('DD/MM/YYYY') : ''
            data[i].latest_login = data[i].latest_login ? moment(data[i].latest_login).add(543,'Y').format('DD/MM/YYYY HH:mm') : ''
        }
        state.data_table = data
    },
    CUT_TABLE(state, data) {
        let index = state.data_table.findIndex(x => x.admin_id === data);
        state.data_table.splice(index, 1)
    },
    SET_EDIT_ID(state,id){
        state.edit_id = id
    },
    SET_AD_GROUP(state, data){
        state.ad_group = data
    },
    SET_USER_TABLE(state, data){
        state.user_table = []
        for(let i = 0,l = data.length; i < l; i++ ){
            data[i].index = 1+i
            data[i].fullname = data[i].firstName+' '+data[i].lastName
            state.user_table.push(data[i])
        }
    },
    SET_EDIT_DATA(state, data){
        state.edit_data = data
        state.edit_data.role_permission = Object.assign(state.permissions, JSON.parse(data.role_permission))
    },
    LOADING(state, status){
        state.loading = status
    }
};

export const Manage_admin = {
    namespaced: true,
    state,
    actions,
    mutations
};